export default __webpack_public_path__ + "static/media/mill.456c5d7e.svg";